import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "64",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M32 60.693c-2.907 0-5.787-.853-8.054-2.533L12.48 49.6c-3.04-2.267-5.414-7.013-5.414-10.773v-19.84c0-4.107 3.014-8.48 6.88-9.92L27.253 4.08c2.64-.987 6.8-.987 9.44 0L50 9.067c3.866 1.44 6.88 5.813 6.88 9.92V38.8c0 3.787-2.374 8.507-5.414 10.773L40 58.133c-2.214 1.707-5.094 2.56-8 2.56M28.666 7.84 15.36 12.827c-2.267.853-4.267 3.733-4.267 6.186v19.814c0 2.533 1.787 6.08 3.787 7.573l11.466 8.56c3.067 2.293 8.24 2.293 11.334 0l11.466-8.56c2.027-1.52 3.787-5.04 3.787-7.573v-19.84c0-2.427-2-5.307-4.267-6.187L35.36 7.813c-1.814-.64-4.907-.64-6.694.027"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M28.426 37.947a1.98 1.98 0 0 1-1.413-.587l-4.293-4.293a2.01 2.01 0 0 1 0-2.827 2.01 2.01 0 0 1 2.826 0l2.88 2.88L38.48 23.067a2.01 2.01 0 0 1 2.826 0 2.01 2.01 0 0 1 0 2.826L29.84 37.36c-.4.4-.907.587-1.414.587"
    }, null, -1)
  ]))]))
}
export default { render: render }